import { LogoContainer, LogoImage } from "./style";
import logo from "res/logo_large.jpg";

export const Logo = () => {
  return (
    <LogoContainer>
      <LogoImage src={logo} alt="Titelbild" />
    </LogoContainer>
  );
};
